var map = {
	"./map_gakuennmae.json": [
		7007,
		7
	],
	"./map_gakuennmae_icon.json": [
		9517,
		517
	],
	"./map_higashiikoma.json": [
		2077,
		77
	],
	"./map_higashiikoma_icon.json": [
		7207,
		207
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 88;
module.exports = webpackAsyncContext;